import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { locales, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const Point = props => (
  <li>
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={['fas', 'circle']} transform="grow-10" />
      <FontAwesomeIcon icon={['fas', 'check']} inverse transform="shrink-3" />
    </span>
    {i18n.translate(`loginScreen.sellingPoints.${props.id}`)}
  </li>
);

export default class SellingPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {
      points: [],
    };
  }

  componentWillMount() {
    let { sellingPoints } = locales.en.loginScreen;
    StorageHandler.exists(storageKeys.lang).then((languageExists) => {
      if (languageExists) {
        StorageHandler.load(storageKeys.lang).then((res) => {
          if (res) {
            ({ sellingPoints } = locales[(res && res.langFile) || 'en'].loginScreen);
            this.setPoints(sellingPoints);
          } else {
            this.setPoints(sellingPoints);
          }
        });
      } else {
        this.setPoints(sellingPoints);
      }
    });
  }

  setPoints(sellingPoints) {
    const { points } = this.state;
    Object.keys(sellingPoints).forEach((point, index) => {
      const key = index;
      points.push(<Point key={`key_${key}`} id={index} />);
    });
    this.setState({ points });
  }

  render() {
    return (
      <ul className="sellingPoints">
        {this.state.points}
      </ul>
    );
  }
}

Point.propTypes = {
  id: PropTypes.number.isRequired,
};
